
import angular from 'angular';
import { AncillariesService } from '../../ib-web-ancillaries/ib-web-ancillaries-service';
import { IbInsuranceAllianzDatalayerUtilsService } from 'src/app/shared/ib-insurance-allianz-datalayer-utils.service';

const controllerInfo = {
    module: 'ib-insurance-allianz-fusion-module',
    inject: ['$uibModalInstance', 'object', '$scope', '$rootScope', 'localStorageService', '$sce', 'AncillariesConstants', 'AncillariesService', 'IbInsuranceAllianzDatalayerUtilsService'],
    required: []
};
export class AllianzFusionMMBModalController implements ng.IController {
    public model:any;
    public market:string = this.$rootScope.appMarket;
    public insuranceForm;
    public isUSMarket:boolean = false;
    public isDNIBound:boolean = !!((this.market === 'ES' || this.market === 'IT'));
    public policyHolder:any;
    public insurancesAvailable: any = [];
    public passengers: any = [];
    public passengersForInsurance: any[];
    public output;
    public marketCountry;
    public requiredByNavigationMarket: any;
    public requiredByStatesSelector: any;
    public codeStateSelected: any;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $sce: any,
        private AncillariesConstants: AncillariesConstant,
        private AncillariesService: AncillariesService,
        private IbInsuranceAllianzDatalayerUtilsService: IbInsuranceAllianzDatalayerUtilsService
    ) {
        this.model = object;
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        const summaryInfo: any = this.localStorageService.get('breakdownInfo');
        this.passengers = summaryInfo.context.passengers;
        this.policyHolder = this.passengers.filter(passenger => passenger.passengerType === 'ADULT')[0];
        const adultsWithInfants = this.passengers.filter(passenger => passenger.infant);
        const insuranceInfants = adultsWithInfants.map( passenger => {
            return passenger.infant;
        });
        this.passengersForInsurance = this.passengers.concat(insuranceInfants);
        this.marketCountry = this.market;
        if(this.market === 'US' || 'BR' || 'MX') {
            this.isUSMarket = true;
        }
        const ancillaries: any = this.localStorageService.get('ancillariesInfo');
        let insuranceInfo: any;
        angular.forEach(ancillaries.ancillaries, (anc) => {
            if (anc.type === 'ALLIANZ_FUSION') {
                insuranceInfo = anc;
            }
        });
        if (insuranceInfo && insuranceInfo.products) {
            angular.forEach(insuranceInfo.products, (ins) => {
                this.insurancesAvailable.push(ins);
            });
            this.insurancesAvailable.sort((a, b) => {
                return Number(a.totalPrice) - Number(b.totalPrice);
            });
            const withoutInsurance = this.insurancesAvailable[0];
            this.insurancesAvailable.shift();
            this.insurancesAvailable.push(withoutInsurance);
            this.formatCall(this.model, this.insurancesAvailable, insuranceInfo);
            this.setStatesSelector();
            this.checkRequiredFields();
        }
    }

    checkRequiredFields = (): void => {
        this.requiredByNavigationMarket = this.model.countriesRequiredInfo.filter(requirement => requirement.countries.find(country => country === this.market))[0];
    };

    setStatesSelector () {
        this.requiredByStatesSelector = this.AncillariesConstants.STATES_SELECTOR.NAMES;
    }

    patternResidentDocument = (market: string) => {
        let patternToAply = '';
        if (market === 'ES') {
            patternToAply = this.model.countriesRequiredInfo[2].passengerTypeRequiredFields[0].requiredFieldsGroups[1].requiredFields[0].pattern;
        } else {
            patternToAply = this.model.countriesRequiredInfo[1].passengerTypeRequiredFields[0].requiredFieldsGroups[1].requiredFields[0].pattern;
        }
        return patternToAply;
    };

    formatCall = (data:any, insurancesAvailable, insuranceInfo) => {
        this.output = this.$sce.trustAsHtml(data.output);
        //this.initEventInAllianz(insurancesAvailable, insuranceInfo);
    };

    changeInsurancePolicyHolder = (selected:any): void => {
        this.policyHolder = selected;
    };

    changeStateSelected = (selected:any): void => {
        this.model.insurance.statePassenger = selected;
        for (let i=0; i < this.AncillariesConstants.STATES_SELECTOR.NAMES.length; i++) {
            if (selected === this.AncillariesConstants.STATES_SELECTOR.NAMES[i]) {
                this.codeStateSelected = this.AncillariesConstants.STATES_SELECTOR.CODES[i];
            }
        }
    };

    close = (): void => {
        this.$uibModalInstance.close();
        angular.element('ib-insurance-allianz-fusion').find('.ib-radio__input:checked').prop('checked', false);
    };

    completeForm = (): void => {
        const insurancesOnTemplate:any = document.querySelectorAll('.ib-radio__input');
        let insuranceSelected: any;
        let insuranceNull: boolean = false;
        for (let i=0; i < insurancesOnTemplate.length; i++) {
            if (insurancesOnTemplate[i].checked) {
                insuranceSelected = this.insurancesAvailable[i];
                if (i === insurancesOnTemplate.length - 1) {
                    insuranceNull = true;
                }
            }
        }
        if (!insuranceNull) {
            this.insuranceForm.$submitted = true;
            if (this.insuranceForm.$valid) {
                const data = this.model.insurance;
                const requestData:any = [];
                this.passengersForInsurance.forEach((pas, index)  => {
                    if (pas.id === this.policyHolder.id) {
                        if (this.isDNIBound) {
                            requestData.push({
                                passengerId: pas.id,
                                passengerType: pas.passengerType,
                                policyHolder: true,
                                values: [
                                    {
                                        type: 'INSURED_BIRTH_DATE',
                                        value: data.passenger[index]?.birthDateYear.year + '-' + data.passenger[index].birthDateMonth + '-' + data.passenger[index].birthDateDay
                                    },
                                    {
                                        type: 'INSURED_FIRSTNAME',
                                        value: pas.name
                                    },
                                    {
                                        type: 'INSURED_LASTNAME',
                                        value: pas.surname
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                        value: data.zipcodePassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                        value: data.countryPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_ADDRESS_CITY',
                                        value: data.cityPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                        value: data.emailPassenger
                                    },
                                    {
                                        type: 'POLICY_HOLDER_NUMBER_DOCUMENT',
                                        value: data.passengerDocument
                                    }
                                ]
                            }
                            );
                        } else if (this.isUSMarket) {
                            const lines = data.addressSecond === undefined ? data.addressFirst : data.addressFirst + ';' + data.addressSecond;
                            requestData.push(
                                {   passengerId: pas.id,
                                    passengerType: pas.passengerType,
                                    policyHolder: true,
                                    values: [
                                        {
                                            type: 'INSURED_BIRTH_DATE',
                                            value:  data.passenger[index]?.birthDateYear.year + '-' + data.passenger[index].birthDateMonth + '-' + data.passenger[index].birthDateDay
                                        },
                                        {
                                            type: 'INSURED_FIRSTNAME',
                                            value: pas.name
                                        },
                                        {
                                            type: 'INSURED_LASTNAME',
                                            value: pas.surname
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                            value: data.zipcodePassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                            value: data.countryPassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_CITY',
                                            value: data.cityPassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                            value: data.emailPassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_STATE',
                                            value: this.codeStateSelected
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_LINES',
                                            value: lines
                                        }
                                    ]
                                }
                            );
                        } else {
                            requestData.push(
                                {   passengerId: pas.id,
                                    passengerType: pas.passengerType,
                                    policyHolder: true,
                                    values: [
                                        {
                                            type: 'INSURED_BIRTH_DATE',
                                            value:  data.passenger[index]?.birthDateYear.year + '-' + data.passenger[index].birthDateMonth + '-' + data.passenger[index].birthDateDay
                                        },
                                        {
                                            type: 'INSURED_FIRSTNAME',
                                            value: pas.name
                                        },
                                        {
                                            type: 'INSURED_LASTNAME',
                                            value: pas.surname
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_ZIPCODE',
                                            value: data.zipcodePassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_COUNTRY',
                                            value: data.countryPassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_ADDRESS_CITY',
                                            value: data.cityPassenger
                                        },
                                        {
                                            type: 'POLICY_HOLDER_CONTACT_EMAIL',
                                            value: data.emailPassenger
                                        }
                                    ]
                                });
                        }
                    } else {
                        requestData.push(
                            {   passengerId: pas.id,
                                passengerType: pas.passengerType || 'INFANT',
                                policyHolder: false,
                                values: [
                                    {
                                        type: 'INSURED_BIRTH_DATE',
                                        value: data.passenger[index] ? data.passenger[index].birthDateYear.year + '-' + data.passenger[index].birthDateMonth + '-' + data.passenger[index].birthDateDay : pas.birthDate
                                    },
                                    {
                                        type: 'INSURED_FIRSTNAME',
                                        value: pas.name
                                    },
                                    {
                                        type: 'INSURED_LASTNAME',
                                        value: pas.surname
                                    }
                                ]
                            });
                    }
                });
                this.modalAllianzClick(requestData, insuranceNull, insuranceSelected);
                this.$uibModalInstance.close();
            }
        } else {
            this.AncillariesService.deleteAllianzFusionInsurance().then(() => {
                this.AncillariesService.deleteAllianzFusionInsuranceFromBasket();
                this.$rootScope.$broadcast('updateInsuranceSelectedStatus', false);
                this.localStorageService.set('allianzFusionSelected', false);
                this.localStorageService.remove('insuranceAllianzFusionPassengerInfo');
                this.$uibModalInstance.close();
            }, angular.noop);
        }
    };

    modalAllianzClick = (requestData, insuranceNull, insuranceSelected) => {
        if (insuranceNull) {
            this.AncillariesService.deleteAllianzFusionInsuranceFromBasket();
            this.$rootScope.$broadcast('updateInsuranceSelectedStatus', false);
            this.localStorageService.set('allianzFusionSelected', false);
            this.localStorageService.remove('insuranceAllianzFusionPassengerInfo');
        } else {
            const code = insuranceSelected.externalCode;
            const price = insuranceSelected.totalPrice;
            const description = insuranceSelected.productSpecificMessages[0].text;
            const updateAllianzInfo = {
                type: 'ALLIANZ_FUSION',
                externalCode: code,
                additionalInfoByPassenger: requestData
            };
            this.localStorageService.set('insuranceAllianzFusionPassengerInfo', updateAllianzInfo);
            this.localStorageService.set('close', this.AncillariesConstants.QUADRIGAM.ANCILLARIES_MMB.toLowerCase());
            this.localStorageService.set('ancillariesAction', 'click');
            this.localStorageService.set('ancillariesAction', 'addtocart');
            this.$rootScope.$broadcast('updateHeaderAllianzFusionInsurance', {
                description,
                price
            });
            this.localStorageService.set('allianzFusionSelected', true);
            this.$rootScope.$broadcast('updateInsuranceSelectedStatus', true);
            this.addEcommerceEvent(insuranceSelected);
        }
    };

    private addEcommerceEvent (insuranceSelected): void {
        this.IbInsuranceAllianzDatalayerUtilsService.selectInsuranceEcommerceEventCart(insuranceSelected, 'select_item');
        this.IbInsuranceAllianzDatalayerUtilsService.selectInsuranceEcommerceEventCart(insuranceSelected, 'add_to_cart');
    }
}


try {
    AllianzFusionMMBModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(AllianzFusionMMBModalController.name, AllianzFusionMMBModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    AllianzFusionMMBModalController.$inject = controllerInfo.inject;
    mod.controller(AllianzFusionMMBModalController.name, AllianzFusionMMBModalController);
}